import React from 'react';
import { ConflictKeywordGq } from '../../../../../../graphql/projects/models/ConflictKeywordGq';
import { ConflictTableState } from './logic/useConflictTableState';
import VoxelTableCheckbox from '../../../../../../components/voxel/Forms/VoxelTableCheckbox';

export interface ConflictsRowCheckboxProps {
  conflict: ConflictKeywordGq;
  tableState: ConflictTableState;
  disabled: boolean;
}

const ConflictsRowCheckbox: React.FC<ConflictsRowCheckboxProps> = React.memo(({ tableState, conflict, disabled }) => {
  // These are memoized because the component is wrapped in React.memo
  const clicked = !!tableState.selectionState.keywordIds[conflict.keywordId];
  const selected = tableState.selectionState.invertSelection ? !clicked : clicked;

  return <VoxelTableCheckbox checked={selected} disabled={disabled} color='slate' />;
}
);

export default ConflictsRowCheckbox;
